// extracted by mini-css-extract-plugin
export default {"logout":"logout-button_logout__p4GFm","svg":"logout-button_svg__ve6-B","text":"logout-button_text__4E-iB"};